import { SchemaCRUD } from '@/components/crud/SchemaCRUD';

const Methodologies = () => {
	return (
		<SchemaCRUD
			entity="methodologies"
			title="Metodologias"
			description="Gerenciar metodologias de verificação e certificação"
			apiEndpoint="v1/methodologies"
		/>
	);
};

export default Methodologies;
